import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  descricao: '',
  codigo: '',
};

export const ContribuinteContext = createContext();

export const ContribuinteProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [contribuinte, setContribuinte] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getContribuinte = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: contribuinte?.filter,
        page: contribuinte?.page,
        size: contribuinte?.size,
        order: contribuinte?.order,
        ...payload,
      });
      setContribuinte((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ContribuinteContext.Provider
      value={{
        getLoading,
        contribuinte,
        getContribuinte,
      }}
    >
      {children}
    </ContribuinteContext.Provider>
  );
};
